import {
  AppBar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Modal,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import { useFormikContext } from "formik";
import {
  AddressReferenceDropDown,
  AutocompleteDropDown,
  TextInput,
} from "../../../../components";
import { useLocales } from "../../../../hooks";
import { forwardRef, useState } from "react";
import { TransitionProps } from "@mui/material/transitions";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import { ApiSlice } from "../../../../features/api/Api";
import { useAppDispatch } from "../../../../app/hooks";
import { params } from "../../../../utils";

export const setAddressesValue = (addresses: any) => {
  const addressItem = addresses.map(
    (address: any, index: number) => `
    Adres ${index + 1}: ${address.address}
    Tarife/Kampanya ${index + 1}: ${address.campaign}
    `
  );
  return addressItem;
};

export const ConnectServiceAddress = ({
  handleClose,
  open,
  setOpenAddress,
}: any) => {
  const formik: any = useFormikContext();
  const { t }: any = useLocales();
  const [loader, setLoader] = useState(false);
  const dispatch = useAppDispatch();

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    maxHeight: "70%",
    overflowY: "auto",
  };

  const getAddressAndInFrustructureByDoorCode = async (doorCode: string) => {
    const result = await dispatch(
      ApiSlice.endpoints.getList.initiate({
        resource: `fixity/setting/turkTelekomAddress/get-address-no-by-bbk-code`,
        params: {
          ...params,
          filter: {
            doorCode,
          },
        },
      })
    );
    const { data: bbkCode }: any = result;
    switch (bbkCode.statusCode) {
      case 200:
        /* setLoader(false);
        setOpenAddress(false) */
        //console.log(bbkCode.data);
        /* formik.setFieldValue("fullAddress", bbkCode.data.acikAdres);
        getInternetInfrastructure(bbkCode.data.kod); */
        getAddressCodeFromBbkCode(bbkCode.data.kod);

        break;

      default:
        setLoader(false);
        setOpenAddress(false);
        Swal.fire({
          title: "BBK Kodu Bulunamadı.",
        });
        break;
    }
  };

  const getInternetInfrastructure = async (bbkCode: string) => {
    const result = await dispatch(
      ApiSlice.endpoints.create.initiate({
        resource: `fixity/setting/turkTelekomAddress/internetInfrastructureQuery`,
        params: [bbkCode],
      })
    );
    const { data: internetInfrastructure }: any = result;
    if (internetInfrastructure.data) {
      setLoader(false);
      setOpenAddress(false);
      formik.setFieldValue(
        "internetInfrustructure",
        internetInfrastructure.data
      );
      formik.setFieldValue(
        "addressInternetSpeed",
        internetInfrastructure.data[1].hiz
      );
      Swal.fire("Başarılı", "Adres ve Altyapı eklendi", "success");
    } else {
      setLoader(false);
      setOpenAddress(false);
      Swal.fire({
        title: "Internet altyapısı bulunamadı.",
      });
    }
  };

  const getAddressCodeFromBbkCode = async (bbkCode: string) => {
    const result = await dispatch(
      ApiSlice.endpoints.getList.initiate({
        resource: `fixity/setting/TurkTelekomAddress/getAddressCodeFromBbkCode`,
        params: {
          ...params,
          filter: {
            bbkCode,
          },
        },
      })
    );
    const { data: addressNo }: any = result;
    formik.setFieldValue("fullAddress", addressNo.data.acikAdres);
    if (addressNo.data) {
      getInternetInfrastructure(bbkCode);
    }
  };

  const handleAddAddress = async () => {
    setLoader(true);
    if (formik.values.selectAddressCategory === 1) {
      if (
        formik.values.addressProduct?.city &&
        formik.values.addressProduct?.town &&
        formik.values.addressProduct?.townShip &&
        formik.values.addressProduct?.village &&
        formik.values.addressProduct?.district &&
        formik.values.addressProduct?.street &&
        formik.values.addressProduct?.building &&
        formik.values.addressProduct?.door
      ) {
        getAddressAndInFrustructureByDoorCode(
          formik.values.addressProduct?.door.value
        );
      } else {
        setLoader(false);
        setOpenAddress(false);
        Swal.fire({
          title: "Lütfen tum alanlari doldurun.",
        });
      }

      formik.setFieldValue("addressProduct.city", "");
      formik.setFieldValue("addressProduct.town", "");
      formik.setFieldValue("addressProduct.townShip", "");
      formik.setFieldValue("addressProduct.village", "");
      formik.setFieldValue("addressProduct.district", "");
      formik.setFieldValue("addressProduct.street", "");
      formik.setFieldValue("addressProduct.building", "");
      formik.setFieldValue("addressProduct.door", "");
      formik.setFieldValue("addressProduct.postalCode", "");
      formik.setFieldValue("addressProduct.address1", "");
    } else {
      getAddressCodeFromBbkCode(formik.values.bbkCode);
    }
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        <Box sx={style}>
          <Grid container spacing={3}>
            <Grid item md={12}>
              <AutocompleteDropDown
                name="selectAddressCategory"
                label="Adres Kategorisi"
                options={[
                  { value: 1, label: "Adres ile Sorgulama" },
                  { value: 2, label: "BBK Kodu ile Sorgulama" },
                ]}
              />
            </Grid>
            {formik.values.selectAddressCategory === 1 ? (
              <>
                <Grid item md={12}>
                  <AddressReferenceDropDown
                    name="addressProduct.city"
                    label="Şehir"
                    reference={`fixity/setting/turkTelekomAddress/get-cities/187cf1ae-023f-ed11-a5f4-005056a2cd35`}
                    optionName="name"
                    optionId="turkTelekomId"
                  />
                </Grid>
                <Grid item md={12}>
                  <AddressReferenceDropDown
                    name="addressProduct.town"
                    label="İlçe"
                    reference={`fixity/setting/turkTelekomAddress/get-towns-by-city-id`}
                    query={{
                      cityId: formik?.values.addressProduct.city?.value,
                    }}
                    optionName="name"
                    optionId="turkTelekomId"
                    skip={!formik.values?.addressProduct?.city?.value}
                    disabled={!formik.values?.addressProduct?.city?.value}
                  />
                </Grid>
                <Grid item md={12}>
                  <AddressReferenceDropDown
                    name="addressProduct.townShip"
                    label="Bucak"
                    reference={`fixity/setting/turkTelekomAddress/get-townships-by-town-id`}
                    query={{
                      townId: formik?.values?.addressProduct?.town?.value,
                    }}
                    optionName="name"
                    optionId="turkTelekomId"
                    skip={!formik.values?.addressProduct?.town?.value}
                    disabled={!formik.values?.addressProduct?.town?.value}
                  />
                </Grid>
                <Grid item md={12}>
                  <AddressReferenceDropDown
                    name="addressProduct.village"
                    label="Köy"
                    reference={`fixity/setting/turkTelekomAddress/get-villages-by-townShip-id`}
                    optionName="name"
                    optionId="turkTelekomId"
                    query={{
                      townShipId:
                        formik?.values?.addressProduct?.townShip?.value,
                    }}
                    skip={!formik.values?.addressProduct?.townShip?.value}
                    disabled={!formik.values?.addressProduct?.townShip?.value}
                  />
                </Grid>
                <Grid item md={12}>
                  <AddressReferenceDropDown
                    name="addressProduct.district"
                    label="Mahalle"
                    reference={`fixity/setting/turkTelekomAddress/get-districts-by-village-id`}
                    optionName="name"
                    optionId="turkTelekomId"
                    query={{
                      villageId: formik.values?.addressProduct?.village?.value,
                    }}
                    skip={!formik.values?.addressProduct?.village?.value}
                    disabled={!formik.values?.addressProduct?.village?.value}
                  />
                </Grid>{" "}
                <Grid item md={12}>
                  <AddressReferenceDropDown
                    name="addressProduct.street"
                    label="Sokak"
                    reference={`fixity/setting/turkTelekomAddress/get-streets-by-district-id`}
                    optionName="name"
                    optionId="turkTelekomId"
                    query={{
                      districtId:
                        formik.values?.addressProduct?.district?.value,
                    }}
                    skip={!formik.values?.addressProduct?.district?.value}
                    disabled={!formik.values?.addressProduct?.district?.value}
                  />
                </Grid>
                <Grid item md={12}>
                  <AddressReferenceDropDown
                    name="addressProduct.building"
                    label="Bina"
                    reference={`fixity/setting/turkTelekomAddress/get-building-numbers-by-street-id`}
                    optionName="name"
                    optionId="turkTelekomId"
                    query={{
                      streetId: formik.values?.addressProduct?.street?.value,
                    }}
                    skip={!formik.values?.addressProduct?.street?.value}
                    disabled={!formik.values?.addressProduct?.street?.value}
                  />
                </Grid>
                <Grid item md={12}>
                  <AddressReferenceDropDown
                    name="addressProduct.door"
                    label="Kapı"
                    reference={`fixity/setting/turkTelekomAddress/get-door-numbers-by-building-id`}
                    optionName="name"
                    optionId="turkTelekomId"
                    query={{
                      buildingId:
                        formik.values?.addressProduct?.building?.value,
                    }}
                    skip={!formik.values?.addressProduct?.building?.value}
                    disabled={!formik.values?.addressProduct?.building?.value}
                  />
                </Grid>
                <Grid item md={12}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleAddAddress}
                    disabled={loader}
                  >
                    {!loader ? (
                      "Adres Ekle"
                    ) : (
                      <CircularProgress color="primary" />
                    )}
                  </Button>
                </Grid>
              </>
            ) : null}
            {formik.values.selectAddressCategory === 2 ? (
              <>
                <Grid item md={12}>
                  <TextInput name="bbkCode" label="BBK Kodu" />
                </Grid>
                <Grid item md={12}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleAddAddress}
                    disabled={loader}
                  >
                    {!loader ? (
                      "Adres Ekle"
                    ) : (
                      <CircularProgress color="primary" />
                    )}
                  </Button>
                </Grid>
              </>
            ) : null}
          </Grid>
        </Box>
      </>
    </Modal>
  );
};
